export default __webpack_public_path__ + "static/make-debt-work-for-you-b4885d6b241abc45645a2044b44d1579.jpg";